import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { QualityPacksGridView } from '../../features/quality-packs/quality-packs-grid-view';

export const Route = createFileRoute('/quality-packs/')({
  staticData: {
    layout: 'full-height',
  },
  component: QualityPacksIndexPage,
});

function QualityPacksIndexPage() {
  const enabled = useFeatureFlag('quality_packs');
  if (!enabled) {
    return (
      <div className="text-muted-foreground p-10 text-center text-sm">
        Quality Packs is not enabled for your partner.
      </div>
    );
  }
  return <QualityPacksGridView />;
}
